import { useMemo, useState } from "react";
import useSWR from "swr";
import { getFetcher } from "../../../services/api";
import IsValidIcon from "../../../components/elements/isValidIcon";
import ReportStatusBadge from "../../../components/elements/ReportStatusBadge";
import ModalConsumptionDetail from "../../../components/fragments/admin/report/consumption/ModalConsumptionDetail";
import { month } from "../../../enums/month";
import useListCompany from "../../useListCompany";
import ModalEditReport from "../../../components/fragments/admin/report/consumption/ModalEditReport";
import { useSelectedCompany } from "../../useSelectedCompany";
import useActivePeriodSelection from "../../useActivePeriodSelection";

export default function useTableConsumption() {
  const [selectedCompany, setSelectedCompany] = useSelectedCompany(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);

  /**
   * Periode default = periode aktif TERLAMA yang laporan penggunaan-nya belum
   * selesai untuk perusahaan ini. Logikanya ada di hook bersama
   * useActivePeriodSelection, dipakai kelima modul pelaporan dengan
   * resourcePath masing-masing.
   */
  const { selectedPeriod, setSelectedPeriod, dataPeriods, isLoadingPeriods } = useActivePeriodSelection(
    selectedCompany?.value,
    "pelaporan-penggunaan-bahan-b3",
  );
  const { dataCompany, isLoadingCompany } = useListCompany();

  const { data, isLoading, mutate } = useSWR(
    selectedCompany?.value && selectedPeriod?.value ? `/api/pelaporan-penggunaan-bahan-b3/search?returnAll=true&companyId=${selectedCompany.value}&periodId=${selectedPeriod.value}` : null,
    getFetcher
  );

  const columnsTableActivePeriod = useMemo(
    () => [
      { field: "id", headerName: "No", valueGetter: (value, row) => row.bulan },
      { field: "perusahaan", headerName: "Perusahaan", valueGetter: (value, row) => row.company.name },
      { field: "jumlahPenggunaanB3", headerName: "Jumlah Penggunaan", valueGetter: (value, row) => `${row.jumlahB3Digunakan} KG` },
      { field: "periode", headerName: "Periode", valueGetter: (value, row) => row.period.name },
      { field: "bulan", headerName: "Bulan", valueGetter: (value, row) => month[row.bulan - 1] },
      {
        field: "status",
        headerName: "Status",
        renderCell: (params) => {
          const { status, jumlahB3Digunakan, laporanTersedia } = params.row;

          // Logika menentukan status Disimpan
          let computedStatus = status;
          if (!status || status === null) {
            if ((jumlahB3Digunakan && jumlahB3Digunakan !== 0 && laporanTersedia === true) || (jumlahB3Digunakan === 0 && laporanTersedia === false)) {
              computedStatus = "Disimpan";
            }
          }

          return <ReportStatusBadge status={computedStatus} />;
        },
        sortable: false,
        filterable: false,
      },
      {
        field: "isFinalized",
        headerName: "Finalisasi",
        renderCell: (params) => (
          <div className="mt-1">
            <IsValidIcon value={params.row.isFinalized} validMessage="Sudah Finalisasi" invalidMessage="Belum Finalisasi" />
          </div>
        ),
      },
      {
        field: "action",
        headerName: "Aksi",
        renderCell: (params) => (
          <div className="flex items-center gap-1">
            <ModalConsumptionDetail data={params.row} />
            {!params.row.isFinalized && <ModalEditReport data={params.row} mutate={mutate} />}
          </div>
        ),
        sortable: false,
        filterable: false,
      },
    ],
    [mutate]
  );

  return {
    table: {
      columnsTableActivePeriod,
      selectedCompany,
      setSelectedCompany,
      selectedMaterial,
      setSelectedMaterial,
      selectedPeriod,
      setSelectedPeriod,
    },
    dataFetchTable: {
      data,
      isLoading,
      mutate,
    },
    dataFetch: {
      dataCompany,
      isLoadingCompany,
      dataPeriods,
      isLoadingPeriods,
    },
  };
}